'use client';
import { useEffect, useState } from 'react';
export const useIsActive = (ref) => {
    const [isActive, setIsActive] = useState(undefined);
    useEffect(() => {
        const refElement = ref.current;
        if (!refElement) {
            return undefined;
        }
        const onMouseDown = () => setIsActive(true);
        const onMouseUp = () => setIsActive(false);
        refElement.addEventListener('pointerdown', onMouseDown);
        refElement.addEventListener('mousedown', onMouseDown);
        refElement.addEventListener('pointerup', onMouseUp);
        refElement.addEventListener('mouseup', onMouseUp);
        return () => {
            refElement.removeEventListener('pointerdown', onMouseDown);
            refElement.removeEventListener('mousedown', onMouseDown);
            refElement.removeEventListener('pointerup', onMouseUp);
            refElement.removeEventListener('mouseup', onMouseUp);
        };
    }, [ref]);
    return isActive;
};
